import api from '@/util/app-api'

class AuthService {
  login (user) {
    return api
      .post('api/token', {
        username: user.username,
        password: user.password,
      }, { authHeader: false, contentType: 'application/x-www-form-urlencoded;charset=utf-8' })
      .then(
        response => {
          if (response.accessToken) {
            response.createAt = new Date()
            localStorage.setItem('user', JSON.stringify(response))
          }
          return response
        })
      .catch(err => {
        return Promise.reject(err)
      })
  }

  logout () {
    localStorage.removeItem('user')
  }

  register (user) {
    return api.post('signup', {
      username: user.username,
      email: user.email,
      password: user.password,
    })
  }
}

export default new AuthService()
